/*
 * editing selection context
 */
import React, { createContext, useContext, useState, useEffect } from 'react';
import {ancestorsFor, globalNodeID, lessonMap } from "../libs/lessonLib";
import { lessonsPaths, explorerPaths, membersPaths, authPaths} from '@mirinae/shared/defines/paths';

const SelectContext = createContext({});

const selectStateInit = {
    selectedNode: null,
    expandedNodes: [],
    figmaSelectedLesson: null,
    figmaSelection: [],
    selectedTextRange: null,
    linkRanges: [],
    selectedLink: null,
    followInPlayer: true,
    autoCollapseOthers: true,
};

export const useSelectContext = (global) => {
    const [selectState, setSelectState] = useState(selectStateInit);
    let navigate;

    const updateSelectState = (update) => {
        if (Object.getOwnPropertyNames(update).length === 1 &&  update.selectedNode && update.selectedNode.nodeClass === 'page')
            selectAndShow(update.selectedNode, { dontCollapseOthers: true });
        else {
            setSelectState((prev) => ({ ...prev, ...update }));
        }
    };

    useEffect(() => {
        const page = global.currentLessonObject && global.currentLessonObject.nodeMap[global.currentPageID];
        if (page && page.nodeClass === 'page')
            selectAndShow(page);
    }, [global.currentPageID]);

    const selectAndShow = (node, options = {}) => {
        let parent = node.nodeClass === 'page' ? node.children[0] || node : node.parent; // if page selected, open first step too
        if (selectState.autoCollapseOthers && !options.dontCollapseOthers)
            selectState.expandedNodes = []; // change to collapse all except the selected node's tree
        while (parent) {
            if (!selectState.expandedNodes.includes(globalNodeID(parent)))
                selectState.expandedNodes.push(globalNodeID(parent));
            parent = parent.parent;
        }
        updateSelectState({ selectedNode: node, expandedNodes: selectState.expandedNodes });
        //
        if (options.showInPlayer)
            showInPlayer(node);
    };

    const showInPlayer = (node) => {
        const lessonObject = lessonMap[node.lessonGuid];
        const page = ancestorsFor(node).page || (node.nodeClass === 'section' ? node.children[0] : node.children[0].children[0]);
        if (page && lessonObject._id && (global.currentLessonObject._id !== lessonObject._id || page.nodeID !== global.currentPageID)) {
            const pageURL = `${lessonsPaths.player}/${lessonObject._id}/${page.nodeID}?edit=1`;
            navigate(pageURL, { replace: true });
        }
    };

    const clear = () => setSelectState({ ...selectStateInit });

    // SelectContext value
    return {
        ...selectState,
        update: updateSelectState,
        selectAndShow,
        showInPlayer,
        clear,
        setNavigate: (n) => navigate = n,
    };
};

export default SelectContext;